/** Entidad (Contactos, clientes, proveedores....)  */

import { Employee } from "./employee";
import { Rol } from "./rol";

export class UserRes {
  count: Number;
  user: User[];
}
export class User {

  id: number;
  username: string;
  name: string;
  email: string;
  password: string;
  create_date: Date;
  enabled: boolean;
  profilePicture: string | null;
  hobbies: string;
  fecha_alt: string;
  fecha_mod: string;
  civil_status: string;
  userRoles: Rol[] = [];
  employee: Employee;

}

export class UserProfilePicture {
  id: number
  profile_picture: string | null
}

export class LoginConfirm {
  username: string
  password: string
}